import { SharinSingleCollaboratorExpenseResponse } from '@/app/models/sharingDetails';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.primary.contrastText,
}));

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  border: 'none',
  padding: theme.spacing(1),
}));

type RuleClassificationTableGridParams = {
  rows: SharinSingleCollaboratorExpenseResponse[];
};

export default function SharingCollaboratorDetailsTable({ rows }: RuleClassificationTableGridParams) {
  const { t } = useTranslation('sharingDetails');

  return (
    <TableContainer sx={{ width: '100%', maxHeight: '30rem', overflow: 'auto' }}>
      <Table stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell>{t('details')}</HeaderTableCell>
            <HeaderTableCell>{t('value')}</HeaderTableCell>
            <HeaderTableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.badge}>
              <RowTableCell>
                <b>{`${row.expenseGroup}`}</b> - {`${row.expenseCode} - ${row.expenseName}`}
              </RowTableCell>
              <RowTableCell>{formatterMonetaryValue(row.value)}</RowTableCell>
              <RowTableCell />
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={3}>
                <Typography variant="subtitle2">{t('no.data.found')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
